import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { UX2, constants as coreConstants } from '@wsb/guac-widget-core';
import Config from '../constants/config';
import DataAid from '../constants/data-aids';
import Event from './event';
import NoEventText from '../noEventText';

const { renderModes: RENDER_MODES } = coreConstants;

class Agenda extends Component {
  static get propTypes() {
    return {
      locale: PropTypes.string,
      events: PropTypes.arrayOf(PropTypes.object).isRequired,
      smallScreen: PropTypes.bool,
      anchorId: PropTypes.string,
      id: PropTypes.string,
      renderMode: PropTypes.string,
      visitorMode: PropTypes.bool,
      staticContent: PropTypes.object,
      isManual: PropTypes.bool.isRequired,
      timezone: PropTypes.object
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      offset: 0
    };
    this.showNextPage = this.showNextPage.bind(this);
    this.showPrevPage = this.showPrevPage.bind(this);
    this.scrollToSectionTop = this.scrollToSectionTop.bind(this);
  }

  renderEvents() {
    const { events, staticContent, locale, isManual, timezone, renderMode } = this.props;
    const beginning = this.state.offset;
    const end = beginning + Config.EVENTS_PER_PAGE;
    const currentEvents = events.slice(beginning, end);

    return currentEvents.map((event, index) => {
      return (
        <UX2.Element.Block key={ event.id }>
          <Event
            staticContent={ staticContent }
            locale={ locale }
            order={ beginning + index }
            isManual={ isManual }
            timezone={ timezone }
            renderMode={ renderMode }
            index={ index }
            { ...event }
          />
        </UX2.Element.Block>
      );
    });
  }

  scrollToSectionTop(e) {
    const { id, renderMode } = this.props;
    if ((RENDER_MODES && renderMode !== RENDER_MODES.PUBLISH) || !id) return;
    e.preventDefault();
    const offsetTop = document.querySelector(`[id='${id}']`).offsetTop;
    const scrollTo = (element, to, duration) => {
      if (duration <= 0) return;
      var difference = to - element.scrollTop;
      var perTick = difference / duration * 10;

      setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
      }, 10);
    };
    scrollTo(document.body, offsetTop, 500);
  }

  renderNavigation() {
    const { events, staticContent = {} } = this.props;
    if (events.length <= Config.EVENTS_PER_PAGE) { return null; }
    const moreEvents = staticContent.moreEvents;
    const renderNextEvents = events.length > Config.EVENTS_PER_PAGE
      && (this.state.offset + Config.EVENTS_PER_PAGE) < events.length;
    return (
      <UX2.Component.Grid bottom={ false } data-aid={ DataAid.CALENDAR_EVENT_NAVIGATION }>
        <UX2.Component.Grid.Cell style={{ marginTop: 'medium' }}>
          { this.renderPrevEventsBtn(moreEvents, renderNextEvents) }
          { renderNextEvents && this.renderNextEventsBtn(moreEvents) }
        </UX2.Component.Grid.Cell>
      </UX2.Component.Grid>
    );
  }

  renderNextEventsBtn(content) {
    const { id } = this.props;
    return (
      <UX2.Element.MoreLink.Forward
        tag='span'
        data-aid={ DataAid.CALENDAR_SHOW_NEXT_EVENTS }
        data-section-jump={ id }
        onClick={ this.showNextPage }
        style={{
          userSelect: 'none'
        }}
        children={ content }
      />
    );
  }

  renderPrevEventsBtn(content, renderingNextButton) {
    if (this.state.offset === 0) { return null; }
    const { id } = this.props;
    return (
      <UX2.Element.MoreLink.Backward
        tag='span'
        data-aid={ DataAid.CALENDAR_SHOW_PREV_EVENTS }
        data-section-jump={ id }
        onClick={ this.showPrevPage }
        style={{
          userSelect: 'none',
          paddingRight: renderingNextButton ? 'small' : 0
        }}
        children={ content }
      />
    );
  }

  showPrevPage(e) {
    this.scrollToSectionTop(e);
    this.setState({ offset: this.state.offset - Config.EVENTS_PER_PAGE });
  }

  showNextPage(e) {
    this.scrollToSectionTop(e);
    this.setState({ offset: this.state.offset + Config.EVENTS_PER_PAGE });
  }

  renderAnchor() {
    if (this.props.anchorId) {
      // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
      return (<a id={ this.props.anchorId }></a>);
    }
  }

  render() {
    if (this.props.events.length > 0) {
      const arrowStyles = `
        .cal-nav-arrow {
          opacity: .8;
          cursor: pointer;
        }
        .cal-nav-arrow:hover {
          opacity: 1;
        }
      `;

      return (
        <UX2.Element.Block>
          <style>{ arrowStyles }</style>
          { this.renderAnchor() }
          <UX2.Component.Grid bottom={ false }>
            <UX2.Component.Grid.Cell>
              <UX2.Element.Block
                key={ this.state.offset }
              >
                { this.renderEvents() }
              </UX2.Element.Block>
              { this.renderNavigation() }
            </UX2.Component.Grid.Cell>
          </UX2.Component.Grid>
        </UX2.Element.Block>
      );
    }
    return (<NoEventText { ...this.props } />);
  }
}

export default Agenda;
